import { render, staticRenderFns } from "./McFontpicker.vue?vue&type=template&id=59237188&"
import script from "./McFontpicker.vue?vue&type=script&lang=js&"
export * from "./McFontpicker.vue?vue&type=script&lang=js&"
import style0 from "./McFontpicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports